import { insertHTML, remove, $, $$ } from 'utils/dom';

const openButtons = $$('.info-modal__open');

if (openButtons.length) {
  const toggleModal = (button, modal) => {
    const isActive = button.classList.contains('is-active');
    if (isActive) {
      remove(modal);
      button.classList.remove('is-active');
    } else {
      insertHTML($('body'), 'beforeend', modal.outerHTML);
      const modalOverlay = $('body > .info-modal__modal');
      modalOverlay.classList.add('is-active');
      button.classList.add('is-active');
      $('.info-modal__close', modalOverlay).addEventListener('click', () =>
        toggleModal(button, modalOverlay)
      );
    }
  };
  openButtons.forEach(button => {
    button.addEventListener('click', () =>
      toggleModal(button, button.nextElementSibling)
    );
  });
}
